module.exports = (require("./helpers/browser/import-polyfill")(parcelRequire.resolve("ld1m8"))).then(() => parcelRequire('2uJnW'));